























import { Component, Prop, Vue } from 'vue-property-decorator';
import ILanguage from '@/app/common/model/ILanguage';
import {Nullable} from '@/app/common/util/Nullable';

@Component({
  name: 'AppLangList',
})
export default class AppLangList extends Vue {
  @Prop() public readonly list!: ILanguage[];
  @Prop() public readonly color!: Nullable<string>;
  @Prop() public readonly currentLang!: string;
}
